module.exports = __webpack_public_path__ + "static/media/LOGO@2x.dba216a2.png";